<template>
  <asd20-viewport
    scrollable
    class="asd20-school-directory__list-view">


    <asd20-notification
      v-if="notification && !notificationDismissed"
      v-bind="notification"
      class="zoomIn"
      @dismiss="notificationDismissed = true"/>

    <transition-group
      ref="viewport"
      class="asd20-school-directory__list-view__viewport"
      name="school-list"
      tag="div"
      appear
    >
      <asd20-school-card
        v-for="school in schools"
        :key="school.abbreviation"
        :school="school"
        @select="onSelect(school)" />
    </transition-group>
  </asd20-viewport>
</template>

<script>
import Asd20SchoolCard from '@/components/molecules/Asd20SchoolCard'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20Notification from '@asd20/ui/src/components/molecules/Asd20Notification'

export default {
  name: 'Asd20SchoolDirectoryListView',
  components: {
    Asd20SchoolCard,
    Asd20Viewport,
    Asd20Notification,
  },
  props: {
    schools: { type: Array, default: () => [] },
  },
  data: () => ({
    notificationDismissed: false
  }),
  computed: {
    selectedEducationLevels() { return this.$store.state.schools.selectedEducationLevels },
    notification() {
      if (this.selectedEducationLevels.indexOf('Preschool') === -1) return null
      return {
        title: 'Interested in Preschool?',
        description: 'Families in Colorado can receive up to 15 hours per week of free, voluntary preschool through the Universal Preschool (UPK) Colorado program.',
        callToActionUrl: 'https://www.asd20.org/preschool',
        callToActionLabel: 'Learn more or apply for Preschool',
        dismissible: true,
        notificationStyle: 'inline',
        importance: 'informational',
      }
    }
  },
  methods: {
    onSelect(school) {
      this.$emit('select', school)
    }
  }
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';

@keyframes zoomIn {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

.zoomIn {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: zoomIn;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  background: asd20-swatch('background-alt', 7) !important;
}

.asd20-school-directory__list-view {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;

  .asd20-card {
    margin: space(0.5) space(0.5) space(0.5) space(0.5);
  }
}

.asd20-school-directory__list-view__viewport {

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.school-list-item {
  position: relative;
  transform: translate3d(0,0,0);
  transition: all asd20-speed(2) $anim-easing;
}
.school-list-enter, .school-list-leave-to {
  opacity: 0;
  transform: transform(0, space(1), 0);
}
.school-list-leave-active {
  position: absolute;
}


@media (min-width: 768px) {
  .asd20-school-directory__list-view__viewport {
    display: flex;
    flex-wrap: wrap;
    .asd20-card {
      width: calc((100% / 2) - #{space(1)});
    }
  }
}

@media (min-width: 1024px) {
  .hide-on-desktop {
    display: none !important;
  }
  .asd20-search-toolbar {
    order: 1;
    border-top: none !important;
  }
  .asd20-school-directory__list-view__viewport {
    padding: space(0.5);
    order: 2;
  }
}

@media (min-width: 1400px) {
  .asd20-school-directory__list {
    justify-content: flex-start;
  }
  .asd20-school-directory__list-view__viewport {
    justify-content: flex-start;
    .asd20-card {
      width: calc((100% / 3) - #{space(1)});
    }
  }
}

@media (min-width: 1800px) {
  .asd20-school-directory__list-view__viewport {
    .asd20-card {
      width: calc((100% / 4) - #{space(1)});
    }
  }
}
@media (min-width: 2300px) {
  .asd20-school-directory__list-view__viewport {
    .asd20-card {
      width: calc((100% / 5) - #{space(1)});
    }
  }
}
</style>
